export const CERTIFICATION_MANAGER_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'REGION_MANAGER',
  'REGION_COMPLIANCE_OFFICER',
  'HR_OFFICER',
  'COORDINATOR',
  'CLINICAL_LEAD',
  'FACILITY_MANAGER',
  'QUALITY_OFFICER',
  'COMPLIANCE_OFFICER',
  'TEAM_LEADER',
];

export const CERTIFICATION_SELF_SERVICE_ROLES = [
  'CARE_WORKER',
  'REGISTERED_NURSE',
  'ENROLLED_NURSE',
  'PERSONAL_CARE_WORKER',
  'ASSISTANT_IN_NURSING',
  'ALLIED_HEALTH',
  'ALLIED_HEALTH_PROFESSIONAL',
  'SOCIAL_SUPPORT_WORKER',
  'DOMESTIC_WORKER',
  'DOMESTIC_ASSISTANCE_WORKER',
  'TRANSPORT_DRIVER',
];

export const CERTIFICATION_VIEW_ROLES = [
  ...CERTIFICATION_MANAGER_ROLES,
  ...CERTIFICATION_SELF_SERVICE_ROLES,
];
